<template>

  <v-card>

    <v-expansion-panel v-if="collapsed">
      <v-expansion-panel-content>
        <template v-slot:header>
          <span class="headline">{{ title }}</span>
        </template>
        <v-card-text>
          <v-form>
            <div v-for="(beanProperty, index) in filteredBeanProperties" :key="beanProperty">
              <span>
              <v-text-field
                class="xs12"
                :value="trimmed(beanProperty)"
                :label="defaultLabels[index]"
                readonly
              ></v-text-field>
              </span>
            </div>
          </v-form>
        </v-card-text>
      </v-expansion-panel-content>
    </v-expansion-panel>

    <v-card-title v-if="title && !collapsed">
      <span class="headline">{{ title }}</span>
    </v-card-title>

    <v-card-text v-if="!collapsed">
      <v-form>
        <div v-for="(beanProperty, index) in filteredBeanProperties" :key="beanProperty">
          <span v-if="hiddenProperties === undefined
          || hiddenProperties[beanProperty] === undefined
          || hiddenProperties[beanProperty] === false">
          <v-text-field
            v-if="beanProperty !== 'status'"
            class="xs12"
            :value="value(beanProperty)"
            :label="defaultLabels[index]"
            readonly
          ></v-text-field>
          <v-text-field
            v-if="beanProperty === 'status'"
            class="xs12 generic-viewer__status-field"
            :class="'status-' + optionalStatusClass(beanProperty)"
            :value="bean[beanProperty]"
            :label="defaultLabels[index]"
            readonly
          ></v-text-field>
          </span>
        </div>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>

import startCase from 'lodash.startcase';

export default {
  name: 'MPayGenericViewer',
  components: {},
  props: {
    title: { type: String, required: false },
    bean: { type: Object, required: true },
    beanProperties: { type: Array, required: true },
    hiddenProperties: { type: Object, required: false },
    beanLabels: { type: Array, required: false },
    roles: { type: Object, required: false },
    loading: { type: Boolean, required: false, default: false },
    statusClasses: { type: Object, required: false },
    formatters: { type: Object, required: false },
    collapsed: { type: Boolean, required: false, default: false },
  },

  data: () => ({}),

  computed: {
    defaultLabels() {
      if (this.beanLabels === undefined) {
        return this.filteredBeanProperties.map((p) => {
          if (p.includes('.')) {
            return startCase(p.substring(p.lastIndexOf('.')));
          }
          return startCase(p);
        });
      }
      return this.beanLabels;
    },
    filteredBeanProperties() {
      return this.beanProperties.filter((p) => {
        if (this.roles && this.roles[p]) {
          return this.$store.getters.hasAnyRole(this.roles[p]);
        }
        return true;
      });
    },
  },

  methods: {
    value(beanProperty) {
      if (this.formatters && this.formatters[beanProperty]) {
        return this.formatters[beanProperty](this.bean[beanProperty]);
      }
      if (beanProperty.includes('.')) {
        const properties = beanProperty.split('.');
        const beanElement = this.bean[properties[0]];
        return beanElement === undefined ? '' : beanElement[properties[1]];
      }
      return this.bean[beanProperty];
    },
    trimmed(beanProperty) {
      const value = this.bean[beanProperty];
      return value ? value.toString().trim() : value;
    },
    optionalStatusClass(beanProperty) {
      return this.statusClasses === undefined ? '' : this.statusClasses[this.bean[beanProperty]];
    },
  },
};
</script>

<style>
  .generic-viewer__status-field input {
    font-size: 14px !important;
    font-weight: bold !important;
  }

  .generic-viewer__status-field.status-error input {
    color: var(--v-error-base) !important;
  }

  .generic-viewer__status-field.status-warning input {
    color: var(--v-warning-base) !important;
  }

  .generic-viewer__status-field.status-info input {
    color: var(--v-info-base) !important;
  }

  .generic-viewer__status-field.status-success input {
    color: var(--v-success-base) !important;
  }
</style>



// WEBPACK FOOTER //
// src/components/MPayGenericViewer.vue